import React from "react"
import Navbar from "../../Common/Navbar"
import Footer from "../../Common/Footer"
import Sidebar from "../../Sidebar/Sidebar"
import ViewUpdateComp from "./Component/ViewUpdateComp"

const ViewUpdate =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <ViewUpdateComp />
        </div>
        <Footer />
        </>
    )
}

export default ViewUpdate